<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 根据登录版本动态设置标题
    this.fUpdatePageTitle();
  },
  methods: {
    /**
     * 根据登录版本更新页面标题
     */
    fUpdatePageTitle() {
      const saasTypeId = this.$store.state.djsAdmin.saas_type_id;
      let title = '餐饮后台管理系统'; // 默认标题

      // 根据不同的 saas_type_id 设置不同的标题
      if (saasTypeId === 'sipCy') {
        title = '餐饮后台管理系统';
      } else if (saasTypeId === 'sipLs') {
        title = '零售后台管理系统';
      } else if (saasTypeId === 'sipHm') {
        title = '行业后台管理系统';
      } else {
        title = '后台管理系统';
      }

      // 更新页面标题
      document.title = title;
    }
  }
}
</script>

<style lang="less">
// 默认主题
 html[data-vxe-ui-theme="light"] {
//   // 字体颜色
//   --vxe-ui-font-color: #000;
//   // 主题颜色
//   --vxe-ui-font-primary-color: #409eff;

//   // 活动颜色
//   --vxe-ui-font-primary-tinge-color: #d4d5d7;
//   // 松开颜色
//   --vxe-ui-font-primary-lighten-color: #797b80;
//   // 按下颜色
//   --vxe-ui-font-primary-darken-color: #47494c;
//   // 禁用颜色
//   --vxe-ui-font-primary-disabled-color: #BFBFBF;

  --vxe-ui-font-color: #000;
  --vxe-ui-header-text-color: #000;
  --vxe-ui-table-border-color: #c4cdd5;
  --vxe-ui-table-row-hover-background-color: #e6eeff;
  --vxe-ui-table-row-hover-striped-background-color: #e6eeff;
  --vxe-ui-table-row-current-background-color: #d9e5ff;
  --vxe-ui-table-row-hover-current-background-color: #d9e5ff;
 }

// // 暗黑主题
// html[data-vxe-ui-theme="dark"] {
//   --vxe-ui-font-color: #a0a3a7;
//   --vxe-ui-font-primary-color: #409eff;

//   --vxe-ui-font-primary-tinge-color: #33353b;
//   --vxe-ui-font-primary-lighten-color: #797b80;
//   --vxe-ui-font-primary-darken-color: #47494c;
//   --vxe-ui-font-primary-disabled-color: #464646;
// }

#app {
  color: #000;
  font-family: Microsoft YaHei;
}



.vxe-table {
  font-family: Microsoft YaHei;
}

.sm-color-blue {
  color: #007afb;
}

body {
  margin: 0px;
  overflow: hidden;
  min-width: 1024px;
  /* 当显示dialog的时候 body 默认多出了一个 paading-right */
  padding-right: 0px !important;
}

.noClear .el-picker-panel__footer .el-button.el-picker-panel__link-btn.el-button--text.el-button--mini {
  display: none;
}



.vxe-toolbar {
  padding: 0px !important;
}

/*滚动条样式*/
// &::-webkit-scrollbar {
//   width: 0;
// }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}






/* 所有表*/
// 表 【滚动条样式】
&::-webkit-scrollbar-thumb {
  background-color: #f1f3f4;
}


.vxe-header--column .vxe-cell {
  font-size: 14px !important;
  color: #000 !important;
}


.el-button--small {
  font-size: 14px;
}

.x-search {
  color: #414141 !important;
  padding: 0px 10px;
}

/* 底 */
// 底 【页的样式】
.el-pagination {
  margin-top: 5px;
  padding: 0px;
  line-height: 36px;
}

.el-button--primary {
  background-color: var(--main-blue) !important;
  border-color: var(--main-blue) !important;
  color: #fff !important;
}

// 底 【页的颜色】
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--main-blue);
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--main-blue);
  color: #ffffff;
}


/* 头部样式 */
// 所有输入框高
.el-input__inner {
  font-family: Microsoft YaHei;
  height: 36px;
  line-height: 36px;
  // color: #000;

}

// .el-form-item__label {
//   color: #000;
// }
// .el-tabs__item {
//   color: #000;
// }


// .el-button {
//   padding: 10px 8px;
// }

// 搜索按钮背景色
.el-input-group__append {
  background-color: #ffffff;
}

// 选中状态颜色
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: var(--main-blue);
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--main-blue);
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--main-blue);
  border-color: var(--main-blue);
}


// 所有头时间样式
// .el-range-editor.el-input__inner {
//   padding: 0px 10px;
// }

.el-date-editor--datetimerange.el-input__inner {
  width: 330px;
}

// .el-date-editor .el-range__icon {
//   line-height: 34px;
// }

.el-date-editor .el-range-separator {
  width: 25px;
  // font-size: 14px;
  // line-height: 36px;
}

.el-date-editor .el-range__close-icon {
  display: none; //清空隐藏
}

// .el-date-editor .el-range-input {
//   width: 130px; // 选择时间宽
// }



/* 对话框样式 */
.el-dialog__header {
  padding: 0px;
}

.el-dialog {
  border-radius: 4rem;
}

.el-dialog__body {
  padding: 0px;
}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--main-blue);
}

.el-dialog__headerbtn {
  right: 30px;
}

// 全局树形控件样式修改
.el-tree-node__content:hover {
  // background-color: #f9fcff !important;
  background-color: rgba(0, 122, 251, 0.1);

}

// 列表 ==> 左


.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  border-radius: 3px;
  // background: #fbf0f0;
  // background-color: transparent;
  background-color: rgba(0, 122, 251, 0.1);
  // color: var(--main-blue);
  // font-weight: 600;
}

.el-tree-node__content {
  height: 32px;
  color: #000;
  // padding: 0 !important;
}

//虚线添加开始===========
.el-tree-node__expand-icon{
 font-size: 16px;
}
// .el-tree>.el-tree-node:after {
//   border-top: none;
// }

// .el-tree-node {
//   position: relative;
//   padding-left: 0;
// }

//节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
// .el-tree-node__expand-icon.is-leaf {
//   display: none;
// }

// .el-tree-node__children {
//   padding-left: 16px;
// }

// .el-tree-node :last-child:before {
//   height: 38px;
// }

// .el-tree>.el-tree-node:before {
//   border-left: none;
// }

// .el-tree>.el-tree-node:after {
//   border-top: none;
// }

.el-tree-node__content>.el-tree-node__expand-icon {
  padding: 0 !important;
}

// .el-tree-node:before {
//   content: "";
//   left: -10px;
//   position: absolute;
//   right: auto;
//   border-width: 1px;
// }

// .el-tree-node:after {
//   content: "";
//   left: -10px;
//   position: absolute;
//   right: auto;
//   border-width: 1px;
// }

// .el-tree-node:before {
//   border-left: 1px solid #cbcdce;
//   bottom: 0px;
//   height: 100%;
//   top: -20px;
//   width: 1px;
// }

// .el-tree-node:after {
//   border-top: 1px solid #cbcdce;
//   height: 20px;
//   top: 17px;
//   width: 10px;
// }

//虚线添加结束===========

//全局导航样式修改
.el-menu-item.is-active {
  background-color: #F1F3F4;
  color: #6C9CFC;
  width: 130px !important;
}

.el-menu {
  border: none !important;
}

.el-menu-item,
.el-submenu__title {
  color: #323233;
  height: 40px !important;
  line-height: 40px !important;
  min-width: unset !important;
}

.el-submenu__title {
  border-bottom: 1px solid #f2f4f6 !important;
  margin-top: 4px !important;
}

.el-menu-item {
  padding: 0 20px !important;
}

// 单选【复选】按钮颜色样式
.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--main-blue);
  background: var(--main-blue);
}

.el-radio__input.is-checked+.el-radio__label {
  color: var(--main-blue);
}

.el-radio__inner:hover {
  border-color: var(--main-blue);
}

.el-checkbox__inner:hover {
  border-color: var(--main-blue);
}




// 树形添加样式
.el-dropdown-menu__item:not(.is-disabled):hover {
  // background: #fbf0f0;
  color: var(--main-blue);
}




// 单选框样式
.el-input__icon {
  line-height: 36px;
}

.el-input__inner{
  border-color: #c4cdd5;
}
.el-select-dropdown__item.selected {
  color: var(--main-blue);
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--main-blue);
}

.el-select .el-input__inner:focus {
  border-color: var(--main-blue);
}




// 所有element 颜色样式
.el-input__inner:focus {
  border-color: var(--main-blue);
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--main-blue);
}

.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: var(--main-blue);
}

.el-date-table td.today span {
  color: var(--main-blue);
}

.el-date-table td.available:hover {
  color: var(--main-blue);
}


.el-button--text {
  color: var(--main-blue);
}

.el-button--text:focus,
.el-button--text:hover {
  color: var(--main-blue);
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #FFF;
  border-color: var(--main-blue);
  color: var(--main-blue);
}

.el-time-panel__btn.confirm {
  color: var(--main-blue);
}

.el-date-table td.current:not(.disabled) span {
  color: #FFF;
  background-color: var(--main-blue);
}

.el-month-table td .cell:hover {
  color: var(--main-blue);
}

.el-month-table td.today .cell {
  color: var(--main-blue);
}

.el-month-table td.end-date .cell,
.el-month-table td.start-date .cell {
  color: #FFF;
  background-color: var(--main-blue);
}



.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--main-blue);
  border-color: var(--main-blue);
}

//  .el-radio-group {
.el-radio-button__inner {
  // background: #fff !important;
  // color: #606266 !important;
  border: 1px solid #E6E6E6 !important;
  transition: all 0.2s !important;
}

// 除了最后一个按钮外，隐藏其他按钮的右边框
.el-radio-button:not(:last-child) .el-radio-button__inner {
  // border-right: none !important;
}

.el-radio-button__orig-radio:checked+.el-radio-button__inner,
.el-radio-button.is-active .el-radio-button__inner {
  color: var(--main-blue) !important;
  background: #fff !important;
  border: 1px solid var(--main-blue) !important;
  box-shadow: none !important;
}

// 确保选中状态下，除最后一个外的按钮右边框仍然隐藏
.el-radio-button:not(:last-child) .el-radio-button__orig-radio:checked+.el-radio-button__inner,
.el-radio-button:not(:last-child).is-active .el-radio-button__inner {
  border-right: 1px solid var(--main-blue) !important;
}

.el-radio-button__inner:hover {
  color: var(--main-blue) !important;
  border-color: var(--main-blue) !important;
  // background: #fff !important;
}
.el-radio__inner::after {
  height: 6px;
  width: 6px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 12px;
}

.el-form-item__error {
  z-index: 10;
  background-color: #ffeeee;
  color: #ff4949;
  padding: 5px 6px;
  margin-top: 0px;
}
:root {
  --main-blue: #007afb;

}
</style>



// WEBPACK FOOTER //
// src/App.vue